import { paramCase } from "change-case"

import DomUtils from "../utils/dom-utils"

import { WINDOW } from "../utils/window-utils"
import { getKey } from "../constants/bind-functions"
import Utils from "../utils/utilities"

const classBind: Function = (elementsToBind: Array<Element>, value: any, className: string) =>
    elementsToBind.forEach(element => {
        if (Utils.isDefined(element) && Utils.isDefined(element.classList)) {
            if (value) element.classList.add(className)
            else element.classList.remove(className)
        }
    })

export default function BindClass(className: string) {
    return (target: any, key: string): any => {
        const elementsToBind: Array<Element> =
            DomUtils.selectAllByQuery(WINDOW.nativeWindow.document, `[${paramCase(key)}]`)

        return {
            set: function (value) {
                this[getKey(key)] = value
                classBind(elementsToBind, value, className)
            },
            get: function() {
                return this[getKey(key)]
            },
            enumerable: true,
            configurable: true
        }
    }
}